<template>
  <div class="buy_complete">
    <div class="info">
      <p class="name">{{this.$route.query.name}}</p>
      <p>我是谜ID：{{this.$route.query.id}}</p>
      <p>欠你一个商品 记得找TA索要呦</p>
    </div>

    <div class="text">
      <p>感谢你对</p>
      <p>{{this.$route.query.name}}</p>
      <p>的支持与爱</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
     document.getElementsByTagName("title")[0].innerText = "我是谜520表白商店";
  },
  methods: {
  }
};
</script>
<style scoped>
.buy_complete {
  width: 100%;
  height: 33.35rem;
  padding: 0 1.375rem;
  padding-top: 8.95rem;
  background: url("../../../assets/images/active/bg/buylist.png") 0 0 no-repeat;
  background-size: cover;
}
.buy_complete .goback{
    font-size:0.5rem;
    color:black;
    background:pink;
    opacity: .6;
    position: absolute;
    top:1.25rem;
    left:1.25rem

}
.buy_complete .info {
  width: 16rem;
  height: 7.5rem;
  padding-top: 2rem;
  margin: 0 auto;
  margin-bottom: 1rem;
  border-radius: 2rem;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.3);
}
.buy_complete .info p.name {
  font-size: 1.2rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(255, 64, 116, 1);
  line-height: 1.5rem;
}

.buy_complete .info p {
  font-size: 0.75rem;
  font-weight: 400;
  color: rgba(255, 64, 116, 1);
  line-height: 1.5rem;
}
.buy_complete .text p {
  text-align: center;
  font-size: 0.75rem;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  color: rgba(117, 86, 98, 1);
}
</style>





// WEBPACK FOOTER //
// src/components/active/view/complete.vue